
export default function ContactInfo() {
  const contactMethods = [
    {
      icon: 'ri-mail-line',
      title: 'Email Us',
      description: 'Our team is here to help',
      info: 'hello@mandapost.com',
      link: 'mailto:hello@mandapost.com',
      color: 'from-[#22577A] to-[#38a3a5]',
    },
    {
      icon: 'ri-question-answer-line',
      title: 'Visit Our FAQ',
      description: 'Find answers to common questions',
      info: 'Browse Frequently Asked Questions',
      link: '/faq',
      color: 'from-[#38a3a5] to-[#66b3ff]',
    },
  ];

  const socialLinks = [
    { icon: 'ri-twitter-x-fill', name: 'Twitter', url: 'https://twitter.com/MandaPostHQ', color: '#000000' },
    { icon: 'ri-linkedin-fill', name: 'LinkedIn', url: 'https://www.linkedin.com/company/mandapost', color: '#0A66C2' },
    { icon: 'ri-facebook-fill', name: 'Facebook', url: 'https://facebook.com/MandaPostHQ', color: '#1877F2' },
    { icon: 'ri-instagram-line', name: 'Instagram', url: 'https://instagram.com/MandaPostHQ', color: '#E4405F' },
    { icon: 'ri-youtube-fill', name: 'YouTube', url: 'https://youtube.com/@MandaPostHQ', color: '#FF0000' },
  ];

  return (
    <div className="space-y-8">
      {/* Contact Methods */}
      <div className="space-y-6">
        {contactMethods.map((method, index) => (
          <a
            key={index}
            href={method.link}
            target={method.icon === 'ri-map-pin-line' ? '_blank' : undefined}
            rel={method.icon === 'ri-map-pin-line' ? 'noopener noreferrer' : undefined}
            className="block bg-white rounded-2xl shadow-lg border-2 border-gray-200 p-6 hover:border-[#66b3ff] hover:shadow-xl transition-all group"
          >
            <div className="flex items-start gap-4">
              <div
                className={`w-14 h-14 bg-gradient-to-br ${method.color} rounded-xl flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform`}
              >
                <i className={`${method.icon} text-white text-2xl`}></i>
              </div>
              <div>
                <h3 className="text-lg font-bold text-[#22577A] mb-1">{method.title}</h3>
                <p className="text-sm text-gray-600 mb-2">{method.description}</p>
                <p className="text-[#38a3a5] font-semibold group-hover:text-[#22577A] transition-colors">
                  {method.info}
                </p>
              </div>
            </div>
          </a>
        ))}
      </div>

      {/* Social Media */}
      <div className="bg-gradient-to-br from-[#e4f4ff]/20 to-[#b3d9ff]/20 rounded-2xl border-2 border-[#66b3ff]/30 p-6">
        <h3 className="text-lg font-bold text-[#22577A] mb-4">Follow Us</h3>
        <div className="flex gap-3">
          {socialLinks.map((social, index) => (
            <a
              key={index}
              href={social.url}
              target="_blank"
              rel="noopener noreferrer"
              className="w-12 h-12 rounded-xl flex items-center justify-center bg-white border-2 border-gray-200 hover:border-[#66b3ff] hover:shadow-lg transition-all group"
              title={social.name}
            >
              <i
                className={`${social.icon} text-xl group-hover:scale-110 transition-transform`}
                style={{ color: social.color }}
              ></i>
            </a>
          ))}
        </div>
      </div>

      {/* Support Badge */}
      <div className="bg-white rounded-2xl border-2 border-dashed border-[#66b3ff] p-6 text-center">
        <div className="flex justify-center mb-4">
          <img
            src="/assets/Postey_Mascot.jpg"
            alt="Postey - MandaPost Mascot"
            className="w-20 h-20 rounded-full object-cover border-4 border-[#66b3ff] shadow-lg hover:scale-110 transition-transform"
          />
        </div>
        <h3 className="text-lg font-bold text-[#22577A] mb-2">Need Immediate Help?</h3>
        <p className="text-sm text-gray-600 mb-4">
          Chat with Postey, our friendly intelligent assistant
        </p>
        <button
          onClick={() => {
            // Dispatch custom event to open chatbot
            window.dispatchEvent(new Event('openChatbot'));
            // Smooth scroll to bottom where chatbot is located
            window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
          }}
          className="inline-flex items-center gap-2 px-6 py-3 bg-gradient-to-r from-[#22577A] to-[#38a3a5] text-white rounded-lg font-semibold hover:shadow-lg hover:scale-105 transition-all cursor-pointer"
        >
          <i className="ri-message-3-line"></i>
          Chat with Postey
        </button>
      </div>
    </div>
  );
}
